var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Markdown',{class:[_vm.component.style ? `style-${_vm.component.style}` : '', _vm.component.class ? _vm.component.class : ''],attrs:{"markdown":_vm.component.content}})
}
var staticRenderFns = []

export { render, staticRenderFns }